import { InstitutionGetSingleByCodeAndTrialCode, InstitutionSingleResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<InstitutionSingleResponse, InstitutionSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<InstitutionSingleResponse, InstitutionSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useInstitution = (trialCode?: string, institutionCode?:string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode && institutionCode ? 
            () => new InstitutionGetSingleByCodeAndTrialCode({ trialCode, code: institutionCode }) : 
            undefined;
    }, [trialCode, institutionCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useInstitution;